module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_18.40d130a3.pdf";